var _symbol, _symbol2, _symbol3, _symbol4;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpritemedalsJa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "gold",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.412 5.572C12.884 7.556 15.668 9.748 18.148 11.028C18.356 10.676 18.644 10.26 18.932 9.972C16.42 8.852 13.652 6.708 11.956 4.388H10.724C9.492 6.404 6.836 8.772 4.068 10.164C4.324 10.42 4.66 10.836 4.804 11.124C7.508 9.684 10.084 7.476 11.412 5.572ZM7.444 9.284V10.372H15.476V9.284H7.444ZM5.38 12.5V13.572H17.556V12.5H5.38ZM4.644 17.556V18.612H18.324V17.556H4.644ZM10.772 9.7V18.116H12.036V9.7H10.772ZM6.708 14.388C7.348 15.284 7.972 16.532 8.18 17.332L9.22 16.884C8.996 16.084 8.34 14.868 7.684 13.988L6.708 14.388ZM15.076 13.956C14.676 14.868 13.924 16.148 13.348 16.932L14.26 17.332C14.852 16.58 15.604 15.428 16.212 14.42L15.076 13.956Z",
    fill: "black"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "silver",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.384 7.66799H17.952V8.70799H12.384V7.66799ZM10.528 17.508C11.904 17.236 13.984 16.74 15.968 16.244L16.096 17.364C14.272 17.844 12.352 18.324 10.88 18.676L10.528 17.508ZM12.4 4.78799H18.592V11.684H12.4V10.596H17.424V5.87599H12.4V4.78799ZM15.456 11.22C16.064 14.228 17.392 16.788 19.648 17.876C19.392 18.1 19.04 18.564 18.864 18.868C16.464 17.556 15.104 14.82 14.432 11.396L15.456 11.22ZM18.4 12.324L19.232 13.14C18.432 13.892 17.344 14.692 16.528 15.22L15.84 14.5C16.624 13.956 17.744 13.012 18.4 12.324ZM11.872 4.78799H13.008V17.62L11.872 17.828V4.78799ZM5.76001 8.08399H10.624V9.10799H5.76001V8.08399ZM4.96001 10.82H11.04V11.876H4.96001V10.82ZM5.29601 12.98L6.14401 12.772C6.48001 13.716 6.76801 14.948 6.83201 15.732L5.93601 15.972C5.88801 15.156 5.61601 13.94 5.29601 12.98ZM4.75201 17.268C6.32001 16.996 8.78401 16.548 11.152 16.084L11.232 17.108C9.05601 17.556 6.72001 18.036 5.02401 18.356L4.75201 17.268ZM9.90401 12.596L10.88 12.868C10.56 13.86 10.208 15.044 9.90401 15.78L9.12001 15.524C9.40801 14.74 9.76 13.46 9.90401 12.596ZM7.56801 8.54799H8.64001V17.188L7.56801 17.364V8.54799ZM7.48801 4.13199H8.12801V4.38799H8.48V4.70799C7.84 5.93999 6.75201 7.65199 5.10401 9.02799C4.92801 8.78799 4.57601 8.41999 4.35201 8.25999C5.85601 7.04399 6.91201 5.41199 7.48801 4.13199ZM7.68001 4.13199H8.576C9.616 5.01199 10.896 6.27599 11.504 7.12399L10.688 8.03599C10.112 7.18799 8.92801 5.81199 7.90401 4.97999H7.68001V4.13199Z",
    fill: "black"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "bronze",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12,
    fill: "#DCB386"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.728 4.83601V18.852H12.784V5.95601H18.688V4.83601H11.728ZM18.24 4.83601V17.444C18.24 17.652 18.144 17.732 17.952 17.732C17.76 17.748 17.12 17.748 16.416 17.716C16.56 18.036 16.704 18.564 16.752 18.852C17.776 18.852 18.384 18.82 18.8 18.644C19.184 18.436 19.312 18.084 19.312 17.444V4.83601H18.24ZM13.488 7.62001V8.66001H17.472V7.62001H13.488ZM13.776 10.292V15.972H14.64V10.292H13.776ZM14.224 10.292V11.252H16.384V14.004H14.224V14.964H17.264V10.292H14.224ZM6.11199 8.10001V9.14001H10.672V8.10001H6.11199ZM5.24799 10.836V11.892H11.104V10.836H5.24799ZM5.61599 12.948C5.91999 13.924 6.17599 15.172 6.19199 16.004L7.08799 15.78C7.02399 14.948 6.76799 13.716 6.44799 12.74L5.61599 12.948ZM5.10399 17.252L5.34399 18.372C7.00799 18.02 9.21599 17.54 11.328 17.076L11.248 16.068C8.99199 16.532 6.65599 16.996 5.10399 17.252ZM10.064 12.596C9.91999 13.444 9.63199 14.708 9.39199 15.492L10.176 15.716C10.448 14.964 10.72 13.812 10.992 12.836L10.064 12.596ZM7.75999 8.48401V17.38L8.81599 17.204V8.48401H7.75999ZM7.71199 4.14801C7.16799 5.42801 6.14399 7.06001 4.68799 8.27601C4.91199 8.43601 5.26399 8.78801 5.43999 9.02801C7.02399 7.63601 8.06399 5.94001 8.68799 4.70801V4.40401H8.33599V4.14801H7.71199ZM7.90399 4.14801V4.99601H8.12799C9.07199 5.78001 10.176 7.10801 10.736 7.89201L11.536 6.98001C10.96 6.18001 9.75999 4.98001 8.79999 4.14801H7.90399Z",
    fill: "black"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "total",
    viewBox: "0 0 27 24"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    fill: "#FCC861"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 6,
    r: 6,
    fill: "#E5E5E5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 18,
    r: 6,
    fill: "#DCB386"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpritemedalsJa);
export default __webpack_public_path__ + "static/media/Spritemedals_ja.60e76a098d7183246216c3efa2645b53.svg";
export { ForwardRef as ReactComponent };